import { Box } from '@stitch-fix/mode-react';
import classNames from 'classnames';
import React from 'react';
import styles from './style.module.scss';
import { JsonRteRenderer } from '../JsonRteRenderer';
import { isEmpty } from '../JsonRteRenderer/JsonRteRenderer';
import { HeroProps } from './Hero';
import { GetStartedButton } from '../GetStartedButton';
import { buttonColorToButtonVariant } from '../ModuleFooter/ModuleFooter';

type ContentItem = Omit<
  Required<NonNullable<HeroProps['items']>[number]>,
  'media'
>;

export type ContentItemsProps = {
  items: ContentItem[];
  activeSlideIndex: number;
};

export const ContentItems = ({
  items,
  activeSlideIndex,
}: ContentItemsProps) => {
  const { contentBackground } = items[activeSlideIndex];

  return (
    <Box
      className={classNames(styles.contentWrapper, {
        [styles.whiteContentBackground]: contentBackground === 'white',
      })}
    >
      <Box data-testid="content" className={styles.content}>
        {items.map((item, index) => {
          // Render all the items, but only the active one will be visible
          // this is to ensure that the content is as wide and tall as largest
          // item to prevent content from jumping around when switching slides

          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              aria-hidden={index !== activeSlideIndex}
              className={classNames(styles.contentItem, {
                [styles.active]: index === activeSlideIndex,
              })}
            >
              <ContentItem {...item} />
            </div>
          );
        })}
      </Box>
    </Box>
  );
};

const ContentItem = ({
  fontColor,
  title,
  subtitle,
  cta,
  buttonColor,
  CtaButton,
}: ContentItem) => {
  return (
    <>
      <Box
        className={classNames({
          [styles.textShadow]: fontColor === 'white',
        })}
        mb={1.5}
      >
        <JsonRteRenderer
          data={title}
          options={{
            textProps: { h1: { color: fontColor } },
          }}
        />
        {!isEmpty(subtitle?.children) && (
          <JsonRteRenderer
            data={subtitle}
            options={{
              textProps: { p: { color: fontColor, spacingBottom: false } },
            }}
          />
        )}
      </Box>
      {CtaButton || (
        <GetStartedButton
          copy={cta.title}
          href={cta.href}
          variant={buttonColorToButtonVariant(buttonColor)}
          eventLocation="hero"
        />
      )}
    </>
  );
};
